export const ROLES = {
    SUPERADMIN: 1,
    DEVELOPER: 5,
    ADMIN: 10,
    COURSE_DESIGNER: 20,
    OPERATORE: 30,
    PARTNER: 40,
    DOCENTE: 50,
    TUTOR: 60,
    CORSISTA: 70
}
